import React, { useEffect } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import { DAYS, WORK_MODES } from 'utils/constants';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import { ENUM_WORK_MODES } from 'utils/enum';

const SetOperatingDays = () => {
  const { operatingDays, setOperatingDays, setIsDisabled, workModes, setWorkModes } =
    useGetStartedActionsContext();

  const toggleDay = (index: number) => {
    const days = [...operatingDays.days];
    const newDay = days[index];
    newDay.is_active = !newDay.is_active;
    days[index] = newDay;
    setOperatingDays({ days });
  };

  useEffect(() => {
    setIsDisabled(
      !Object.values(operatingDays.days).some((d) => d.is_active) || workModes.length === 0
    );
  }, [operatingDays, workModes]);

  const changeWorkMode = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    if (checked) {
      setWorkModes([...workModes, name as ENUM_WORK_MODES]);
    } else {
      setWorkModes([...workModes.filter((mode) => mode !== name)]);
    }
  };

  return (
    <div>
      <div className='max-w-[390px] flex flex-col gap-10'>
        <article className='flex flex-col gap-3'>
          <h3 className='text-[32px] leading-[41.6px] font-semibold'>Set office operating days</h3>
          <p className='text-gray-9'>Select office opening and closing days</p>
        </article>
        <div className='rounded-sm border border-[#EFF0F0] px-4 py-3 '>
          <p className='text-sm font-medium  pb-4'>Select operating days</p>
          <div className=' grid grid-cols-3 gap-4'>
            {operatingDays.days?.map((day, index) =>
              [0, 6].includes(index) ? null : (
                <Input
                  key={index}
                  type='checkbox'
                  label={DAYS[index]}
                  checked={day.is_active}
                  onChange={() => toggleDay(index)}
                />
              )
            )}
          </div>
        </div>
        <div className='rounded-sm border border-[#EFF0F0] px-4 pt-3 '>
          <p className='font-medium text-sm'>Select work mode</p>
          <div className=' mt-1'>
            {WORK_MODES.map((mode, index) => (
              <div
                key={index}
                className={`flex items-center justify-between gap-4 ${
                  index + 1 !== WORK_MODES.length && 'border-b border-b-[#EFF0F0]'
                } py-3`}>
                <Input
                  key={index}
                  name={mode.id}
                  type='checkbox'
                  label={mode.name}
                  checked={workModes.includes(mode.id as ENUM_WORK_MODES)}
                  onChange={changeWorkMode}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetOperatingDays;
